export class AuthComponentModel {
    id: number;
    medicoId?: number;
    empresaId: number;
    coordinador: string;
    administrativa: string;
    medicoNombre: string;
    coordinatorNombre: string;
    usuarioAbreviacion: string;
    tasktype: number;
}
